module.exports = __webpack_public_path__ + "static/media/fax.2e302140.svg";